import React, { useState } from 'react';
import { Mail, X } from 'lucide-react';
import ContactForm from './ContactForm';

/**
 * Floating "Contact Us" button that appears fixed to the bottom-right corner
 * of every page. Opens the ContactForm in a modal.
 */
export const FloatingContactButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating trigger button */}
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 left-6 z-40 flex items-center gap-2 bg-gradient-to-r from-teal-500 to-emerald-500 hover:from-teal-600 hover:to-emerald-600 text-white px-5 py-3 rounded-full shadow-2xl hover:shadow-teal-500/50 hover:scale-105 transition-all font-bold text-sm md:text-base group"
        data-testid="floating-contact-btn"
        aria-label="צור קשר"
      >
        <Mail className="w-5 h-5 md:w-6 md:h-6 group-hover:animate-pulse" />
        <span className="hidden md:inline">צור קשר</span>
      </button>

      {/* Modal */}
      {open && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid="floating-contact-modal"
        >
          <div
            className="bg-white rounded-3xl p-6 md:p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 left-4 w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors"
              data-testid="floating-contact-close-btn"
              aria-label="סגור"
            >
              <X className="w-5 h-5 text-slate-700" />
            </button>
            <ContactForm onClose={() => setOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingContactButton;
